import React from 'react'
import DateTimePicker from './DateTimePicker'
import { Grid } from '@mui/material'
import useBoolean from 'common/hooks/useBoolean'
import PropTypes from 'prop-types'
import { isNil } from 'lodash'

const DateTimeRangePicker = ({
    label = '',
    value = [],
    onChange = () => {},
}) => {
    const {
        value: focused,
        setTrue: onFocus,
        setFalse: onBlur,
    } = useBoolean(false)

    const [start, end] = value

    return (
        <Grid container spacing={1}>
            <Grid size='grow'>
                <DateTimePicker
                    label={label}
                    value={start}
                    onChange={v => {
                        const newDate = [
                            !isNil(end) && !isNil(v) ? Math.min(v, end) : v,
                            end,
                        ]
                        onChange(newDate)
                    }}
                    format='DD/MM/YYYY HH:mm'
                    onFocus={onFocus}
                    onBlur={onBlur}
                    focused={focused}
                />
            </Grid>
            <Grid size='auto' sx={{ marginTop: label ? '18px' : '2px' }}>
                -
            </Grid>
            <Grid size='grow'>
                <DateTimePicker
                    label={label && ' '}
                    value={end}
                    onChange={v => {
                        const newDate = [
                            start,
                            !isNil(end) && !isNil(v) ? Math.max(v, end) : v,
                        ]
                        onChange(newDate)
                    }}
                    format='DD/MM/YYYY HH:mm'
                    onFocus={onFocus}
                    onBlur={onBlur}
                    focused={focused}
                />
            </Grid>
        </Grid>
    )
}

DateTimeRangePicker.propTypes = {
    label: PropTypes.string,
    value: PropTypes.arrayOf(PropTypes.number), // [startDate, endDate]
    onChange: PropTypes.func, // ([startDate, endDate]) => {}
}

export default DateTimeRangePicker